import { render, staticRenderFns } from "./PagesCustomToplistWidget.vue?vue&type=template&id=4ecb23f0&"
import script from "./PagesCustomToplistWidget.vue?vue&type=script&lang=js&"
export * from "./PagesCustomToplistWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports